import axios from 'axios';
import { getAnnotationUrl, getGLobalRepoUrl } from './api-services';
import urls from './urls';
import { $session } from '@/helpers';

export const saveAnnotationsFact = data => axios.post(getAnnotationUrl(), data);


export const updateAnnotationsFact = data => axios.put(getAnnotationUrl(), data);

export const deleteAnnotationsFact = id => axios.delete(getAnnotationUrl(`/${id}`));

export const reorderAnnotationsFact = (id, source, data) => axios.post(getAnnotationUrl(`${urls.order}/${id}/${source}`), data);

export const getAnnotationById = (id, token) => axios.get(getAnnotationUrl(`/${id}`), {
  headers: {
    authorization: token,
  },
});

export const copyAnnotationsForNewSlide = data => axios.post(getAnnotationUrl(`${urls.copy}`), data);

export const copyGroupChatAnnotationsFact = data => axios.post(getAnnotationUrl(`${urls.groupChat}${urls.copy}`), data);

export const createPollFact = data => axios.post(getAnnotationUrl(urls.poll), data);

export const updatePollFact = data => axios.put(getAnnotationUrl(urls.poll), data);

export const getPollsBySlideIdFact = params => axios.get(getAnnotationUrl(`${urls.poll}/bySlideId`), {
  params,
});

export const getPollByIdFact = params => axios.get(getAnnotationUrl(`${urls.poll}/byPollId`), {
  params,
});

export const deletePollFact = params => axios.delete(getAnnotationUrl(urls.poll), {
  params,
});

export const savePollResultFact = params => axios.post(
  getAnnotationUrl(`${urls.poll}${urls.results}`),
  null,
  { params },
);

export const getAnnotationsBySlideFact = (ids, source) => {
  return axios.post(getAnnotationUrl(`${urls.all}${urls.bySource}?source=${source}`), ids);
};

export const getAnnotationsForPublicSite = (ids, source) => {
   const tenantData =$session.getTenantData()
  return axios.post(getGLobalRepoUrl(`${urls.annotations}${urls.all}${urls.bySource}?source=${source}`), ids, {
    headers: {
      'X-TenantID': tenantData && tenantData.id ? tenantData.id : null,
    },
  });
};
